import About from 'components/About';
import Contact from 'components/Contact';
import Cookie from 'components/CookieConsent';
import Footer from 'components/Footer';
import Header from 'components/Header'
import Home from 'components/Home'
import InitialAnimation from 'components/InitialAnimation';
import Projects from 'components/Projects';
import ScrollToTop from 'components/Scroll-To-Top';
import Skills from 'components/Skills';
import useIntersectionObserver from 'components/InitialAnimation/useIntersectionObserver';
import React, { useEffect, useState } from 'react'
import LanguageSelector from 'components/LanguageSelector';
import { Outlet } from 'react-router-dom';
import WarningDarkMode from 'components/WarningDarkMode';


export default function MainPage() {
  const [darkMode, setDarkMode] = useState(false);//state used to control the switch between dark and light mode of the page.
  const [animationCompleted, setAnimationCompleted] = useState(false);// state used to control whether or not the initial animation will be complete to render the components in the page via used effect.
  const [currentProject, setCurrentProject] = useState(null); //state used for manipulate data from projects clicked in projects section , and give that info to another components to handle with pop up open.

  useEffect(() => {
    if (!animationCompleted) return;
    if (darkMode) {
      document.body.classList.remove('light-mode');
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
      document.body.classList.add('light-mode');
    }
  }, [darkMode, animationCompleted]);
  

  const handleAnimationComplete = () => {
    setAnimationCompleted(true);
  };
  
  useIntersectionObserver(animationCompleted);
  

  return (
    <main>
      {!animationCompleted ? (
        <InitialAnimation onAnimationComplete={handleAnimationComplete} />
      ) : (
        <>
          <Header darkMode={darkMode} setDarkMode={setDarkMode} currentProject={currentProject}/>
          <Cookie darkMode={darkMode} currentProject={currentProject} />
          <ScrollToTop darkMode={darkMode} currentProject={currentProject} showBelow={600}/>
          <Home darkMode={darkMode} />
          <LanguageSelector darkMode={darkMode} currentProject={currentProject} />
          <WarningDarkMode setDarkMode={setDarkMode} darkMode={darkMode}/>
          <Outlet /> 
          <About/>
          <Skills />
          <Projects darkMode={darkMode} currentProject={currentProject} setCurrentProject={setCurrentProject} />
          <Contact />
          <Footer />
        </>
      )}
    </main>
  )
}
